import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Popover, Svg, Text } from '@hopskipdrive/react-components';
import { ArrowDropDown } from '@mui/icons-material';

import { getClassifications } from '../../../api/services/Incidents';
import IncidentClassificationDropdown from '../../../components/IncidentClassificationDropdown';
import { IncidentClassification } from '../../../types/incidents';
import { CloseButton, FilterButton, FilterTypeContainer } from '../FilterPanel.styles';

import { CustomPopper } from './ClassificationFilter.styles';

export const ClassificationFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState<IncidentClassification | null>(null);
  const isActive = Object.fromEntries(searchParams.entries()).classification;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onChange = (classfication) => {
    const newParams = new URLSearchParams(searchParams);

    newParams.delete('classification');
    newParams.delete('classificationPriority');
    newParams.delete('classificationLabel');

    if (classfication) {
      newParams.set('classification', encodeURIComponent(classfication.id));
      newParams.set('classificationPriority', encodeURIComponent(classfication.priority));
      newParams.set('classificationLabel', encodeURIComponent(classfication.name));
    }

    setValue(classfication);
    setSearchParams(newParams);
    handleClose();
  };

  const initialize = async () => {
    const classificationId = searchParams.get('classification');

    if (classificationId) {
      const result = await getClassifications({ id: classificationId });

      if (result.data.length > 0) {
        setValue(result.data[0]);
      }
    }
  };

  useEffect(() => {
    initialize();
  }, []);

  const id = open ? 'classification-filter-popover' : undefined;

  return (
    <>
      <FilterButton variant="text" open={open} active={Boolean(isActive)} onClick={handleOpen}>
        Classification <ArrowDropDown />
      </FilterButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ '.MuiBackdrop-root': { backgroundColor: 'transparent' } }}
      >
        <FilterTypeContainer sx={{ width: '30rem' }}>
          <Box className="filter-header">
            <Text variant="body2">Filter by Classification</Text>
            <CloseButton onClick={handleClose}>
              <Svg icon="cross" />
            </CloseButton>
          </Box>
          <IncidentClassificationDropdown
            open={true}
            value={isActive ? value : null}
            onChange={onChange}
            popper={CustomPopper}
          />
        </FilterTypeContainer>
      </Popover>
    </>
  );
};
